import React from "react";
import TableRow from "./TableRow";
import TableData from "./TableData";

const TableBody = ({ data, bottomLine, handleOnSelectRow }) => {
  return (
    <tbody>
      {data.map((row, rowIndex) => (
        <TableRow
          className={"hover:bg-blue-50"}
          key={`table-row-${rowIndex}`}
          bottomLine={bottomLine ? true : rowIndex + 1 !== data.length}
          onClick={() => handleOnSelectRow(row)}
        >
          {row.map((item, index) => (
            <TableData key={`table-data-${index}`}>{item}</TableData>
          ))}
        </TableRow>
      ))}
    </tbody>
  );
};

export default TableBody;
